import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { type ComponentProps } from "react";

import { cn } from "../../utils/cn.util";

export type DropdownMenuSubContentProps = ComponentProps<typeof DropdownMenuPrimitive.SubContent>;

export const SubContent = ({ ref, className, ...props }: DropdownMenuSubContentProps) => (
  <DropdownMenuPrimitive.SubContent
    ref={ref}
    className={cn(
      "z-50 flex min-w-[240px] flex-col gap-1 overflow-hidden rounded-lg border border-neutral-96 bg-white p-2 shadow-lg",
      `data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95`,
      className
    )}
    avoidCollisions={props.avoidCollisions ?? true}
    {...props}
  />
);

SubContent.displayName = DropdownMenuPrimitive.SubContent.displayName;
